import { FormProvider, useForm } from 'react-hook-form'
import { HistoryUserLogReqParams } from '@/services/history/history.types'
import { useGetHistoryUserLog } from '@/services/history/useHistoryQuries'
import { useCallback } from 'react'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { defaultValues, UserLogForm } from '@/pages/history/userLog/components/UserLogForm'
import { UserLogTable } from '@/pages/history/userLog/components/UserLogTable'
import { flushSync } from 'react-dom'
import MAlert from '@/utils/modal/MAlert'
import { EMPTY_EVT_DATE_MESSAGE } from '@/services/history/consts'
import { MenuStorage } from '@/utils/storage/MenuStorage'
import { useMenuOnSession } from '@/components/layout/MainMenuOnSessionProvider'
import { PageLayout } from '@/components/layout/PageLayout'
import { VStack } from '@musinsa/mwms-ds'
import TitleSection from '@/components/content/TitleSection'

function UserLog() {
  const { reload } = useMenuOnSession()
  const { parsedQs, replaceQuery } = useParsedQuery<HistoryUserLogReqParams>(defaultValues)

  const form = useForm<HistoryUserLogReqParams>({
    defaultValues: parsedQs,
  })

  // URL 에서 다시 읽은 parsedQs 로 조회하면 qs.parse 가 이메일의 + 를 공백으로 바꾼다 — 폼 값으로 조회한다(HS03 와 같다)
  const { data, isError, isFetching, refetch } = useGetHistoryUserLog(form.watch())

  const onSearch = useCallback((values: HistoryUserLogReqParams) => {
    const [startDate, endDate] = values.evtDate
    if (!startDate || !endDate) {
      MAlert.show(EMPTY_EVT_DATE_MESSAGE)
      return
    }
    MenuStorage.menuOnSession.setSearch(values)
    flushSync(() => replaceQuery(values))
    reload()
    refetch()
  }, [])

  return (
    <FormProvider {...form}>
      <PageLayout gap={16}>
        <VStack gap={12}>
          <TitleSection variant="legacy" title="사용자 로그" />
          <UserLogForm onSearch={onSearch} />
        </VStack>
        {/* 재조회가 실패해도 react-query 는 직전 결과를 남긴다 — 새 조건의 결과로 오해하지 않게 비운다 */}
        <UserLogTable data={isError ? [] : data?.list ?? []} isLoading={isFetching} />
      </PageLayout>
    </FormProvider>
  )
}

export default UserLog
